import styles from "./supportFoorter.module.css";

export function SupportFooter() {
    return(
        <div className={styles.supportFooter}>
            <p>Em caso de dúvidas ou problemas na plataforma por favor contatar:</p>
            <a href="mailto:DigitalFactory.Support@br.bosch.com">
                DigitalFactory.Support@br.bosch.com
            </a>
        </div>
    );
}